export const ptBRCommon = {
  locale: {
    label: 'Idioma',
    ptBR: 'Portugues (BR)',
    enUS: 'English (US)',
  },
  nav: {
    dashboard: 'Painel',
    expenses: 'Despesas',
    bills: 'Contas',
    categories: 'Categorias',
    accounts: 'Carteiras',
    reports: 'Relatorios',
    investments: 'Investimentos',
    search: 'Buscar',
    settings: 'Configuracoes',
    lists: 'Listas',
    agenda: 'Agenda',
    home: 'Início',
    // Product/section name — intentionally identical in both locales.
    backstage: 'Backstage',
    group: {
      finance: 'Finanças',
      household: 'Casa',
    },
  },
  errorFallback: {
    title: 'Algo deu errado',
    message: 'Ocorreu um erro inesperado.',
    reload: 'Recarregar',
  },
  hub: {
    title: 'Início',
    subtitle: 'Escolha para onde ir',
    financeDesc: 'Despesas, contas, relatórios e investimentos',
    listsDesc: 'Listas de compras e tarefas',
    agendaDesc: 'Eventos e agenda compartilhada',
    badge: {
      billsDue_one: '{{count}} conta a vencer · {{total}}',
      billsDue_other: '{{count}} contas a vencer · {{total}}',
      billsNone: 'Nenhuma conta a vencer esta semana',
      openItems_one: '{{count}} item aberto',
      openItems_other: '{{count}} itens abertos',
      openItemsNone: 'Tudo em dia',
      nextEvent: 'Próximo: {{title}}',
      noEvents: 'Sem eventos nas próximas 24h',
    },
  },
  auth: {
    signIn: 'Entrar',
    signingIn: 'Entrando...',
    email: 'E-mail',
    password: 'Senha',
    emailPlaceholder: 'voce@exemplo.com',
    passwordPlaceholder: 'Digite sua senha',
    invalidCredentials: 'E-mail ou senha invalidos',
    signInToAccount: 'Entre na sua conta',
    validationEmail: 'Por favor, insira um endereco de e-mail valido',
    validationPassword: 'Senha e obrigatoria',
    signInWithGoogle: 'Entrar com Google',
    googleNoAccount: 'Nenhuma conta encontrada para este e-mail. Entre em contato com o administrador.',
    googleError: 'Falha ao entrar com Google. Tente novamente.',
    or: 'ou',
    signUp: 'Criar conta',
    signingUp: 'Criando conta...',
    createAccount: 'Crie sua conta',
    alreadyHaveAccount: 'Ja tem uma conta?',
    dontHaveAccount: 'Nao tem uma conta?',
    name: 'Nome',
    namePlaceholder: 'Seu nome',
    confirmPassword: 'Confirmar senha',
    confirmPasswordPlaceholder: 'Confirme sua senha',
    validationName: 'Nome e obrigatorio',
    validationPasswordMin: 'A senha deve ter pelo menos 8 caracteres',
    validationPasswordMatch: 'As senhas nao conferem',
    signUpWithGoogle: 'Criar conta com Google',
    emailTaken: 'Ja existe uma conta com este e-mail',
    signUpSuccess: 'Conta criada! Verifique seu e-mail para ativar sua conta.',
    verifyEmailTitle: 'Verifique seu e-mail',
    verifyEmailMessage: 'Enviamos um link de verificacao para {{email}}. Verifique sua caixa de entrada.',
    verifyEmailChecking: 'Verificando seu e-mail...',
    verifyEmailSuccess: 'E-mail verificado! Redirecionando...',
    verifyEmailExpired: 'Este link de verificacao expirou.',
    verifyEmailInvalid: 'Este link de verificacao e invalido.',
    verifyEmailAlreadyUsed: 'Este e-mail ja foi verificado.',
    resendVerification: 'Reenviar e-mail de verificacao',
    resendVerificationSent: 'E-mail de verificacao enviado!',
    emailNotVerified: 'Por favor, verifique seu e-mail antes de entrar.',
    joinHousehold: 'Entrar em {{household}}',
    invitedBy: 'Convidado por {{name}}',
    acceptInvite: 'Aceitar convite e criar conta',
    inviteExpired: 'Este convite expirou.',
    inviteNotFound: 'Este link de convite e invalido.',
    inviteUsed: 'Este convite ja foi usado.',
    inviteAccepting: 'Criando sua conta...',
  },
  actions: {
    edit: 'Editar',
    delete: 'Excluir',
    cancel: 'Cancelar',
    save: 'Salvar',
    create: 'Criar',
    saving: 'Salvando...',
    creating: 'Criando...',
    logout: 'Sair',
  },
  states: {
    loading: 'Carregando...',
    error: 'Erro',
    empty: 'Nenhum item encontrado',
  },
  today: 'Hoje',
  confirmDelete: 'Excluir',
  deleting: 'Excluindo...',
  investments: {
    title: 'Investimentos',
    add: 'Adicionar investimento',
    empty: {
      title: 'Nenhum investimento cadastrado',
      subtitle: 'Comece adicionando seu primeiro investimento para acompanhar sua carteira',
      cta: 'Adicionar investimento',
    },
    form: {
      createTitle: 'Novo Investimento',
      editTitle: 'Editar Investimento',
      name: 'Nome',
      namePlaceholder: 'Ex: Tesouro Selic 2029',
      type: 'Tipo',
      typeFixed: 'Renda Fixa',
      typeVariable: 'Renda Variavel',
      institution: 'Instituicao',
      institutionPlaceholder: 'Ex: Tesouro Direto',
      investedAmount: 'Valor Investido',
      currentValue: 'Valor Atual',
      purchaseDate: 'Data da Compra',
      maturityDate: 'Data de Vencimento',
      yieldInfo: 'Rentabilidade',
      yieldInfoPlaceholder: 'Ex: 110% CDI',
      save: 'Salvar',
      saving: 'Salvando...',
      create: 'Criar Investimento',
      update: 'Atualizar',
      delete: 'Excluir',
    },
    toast: {
      created: 'Investimento criado',
      updated: 'Investimento atualizado',
      deleted: 'Investimento excluido',
      createError: 'Erro ao criar investimento',
      updateError: 'Erro ao atualizar investimento',
      deleteError: 'Erro ao excluir investimento',
    },
    confirmDelete: "Tem certeza que deseja excluir '{{name}}'?",
    totalInvested: 'Total Investido',
    totalCurrent: 'Valor Atual Total',
    gainLoss: 'Ganho/Perda',
    detail: {
      edit: 'Editar',
      maturityDate: 'Vencimento',
      yieldInfo: 'Rendimento',
      purchaseDate: 'Data da compra',
    },
    charts: {
      tabEvolution: 'Evolu\u00e7\u00e3o',
      tabAllocation: 'Aloca\u00e7\u00e3o',
      portfolioValue: 'Valor da carteira',
      totalInvested: 'Total investido',
      hintMoreSnapshots: 'Adicione mais snapshots para ver a evolu\u00e7\u00e3o',
      noData: 'Sem dados',
    },
    snapshots: {
      title: 'Hist\u00f3rico de Valores',
      record: 'Registrar valor',
      empty: 'Nenhum registro de valor. Registre o primeiro valor para acompanhar a evolu\u00e7\u00e3o.',
      form: {
        createTitle: 'Registrar Valor',
        editTitle: 'Editar Valor',
        value: 'Valor',
        date: 'Data',
      },
      confirmDelete: 'Excluir registro de {{date}} ({{value}})?',
      toast: {
        created: 'Valor registrado',
        updated: 'Valor atualizado',
        deleted: 'Valor exclu\u00eddo',
        error: 'Erro ao salvar valor',
      },
    },
  },
  previousMonth: 'Mes anterior',
  nextMonth: 'Proximo mes',
  keyboard: {
    title: 'Atalhos de Teclado',
    navigation: 'Navegacao',
    goToDashboard: 'Ir para o Painel',
    goToExpenses: 'Ir para Despesas',
    goToBills: 'Ir para Contas',
    goToReports: 'Ir para Relatorios',
    goToSearch: 'Ir para Busca',
    goToLists: 'Ir para Listas',
    goToAgenda: 'Ir para Agenda',
    showHelp: 'Mostrar atalhos de teclado',
    monthNavigation: 'Navegacao por Mes',
    previousMonth: 'Mes anterior',
    nextMonth: 'Proximo mes',
    listNavigation: 'Navegacao na Lista',
    moveDown: 'Mover para baixo',
    moveUp: 'Mover para cima',
    openDetail: 'Abrir detalhe',
    actions: 'Acoes',
    togglePaid: 'Alternar pago/nao pago',
    editSelected: 'Editar selecionado',
    deleteSelected: 'Excluir selecionado',
    general: 'Geral',
    closeOrDeselect: 'Fechar modal / Desselecionar',
  },
  pwa: {
    install: {
      androidMessage: 'Instale o Nomi na sua tela inicial para acesso rápido.',
      iosMessage: 'Instale o Nomi na sua tela inicial:',
      iosInstructions: 'Toque em <1>Compartilhar</1> e depois <3>Adicionar à Tela de Início</3>',
      notNow: 'Agora não',
      install: 'Instalar',
      dismiss: 'Dispensar',
    },
    update: {
      message: 'Nova versão disponível',
      notNow: 'Agora não',
      update: 'Atualizar',
    },
  },
  offline: {
    banner: 'Você está offline — mostrando dados salvos',
    pendingSync_one: '{{count}} alteração pendente',
    pendingSync_other: '{{count}} alterações pendentes',
    updatedAgo: 'Atualizado {{ago}}',
    writeUnavailable: 'Indisponível offline',
    syncFailed: 'Algumas alterações offline não puderam ser sincronizadas',
  },
} as const;
